import React from 'react';
import composeClassNames from 'utils/composeClassNames';
import './Checkbox.css';

function Checkbox({ id, value, checked, children, disabled, onChange }) {
    const classNames = composeClassNames([
        'Checkbox',
        disabled ? 'Checkbox--disabled' : '',
        checked ? 'Checkbox--checked' : '',
    ]);

    return (
        <label htmlFor={id} className={classNames}>
            <input
                id={id}
                className="Checkbox__input"
                type="checkbox"
                disabled={disabled}
                value={value}
                checked={checked}
                onChange={onChange}
            />
            <span className="Checkbox__text">{children}</span>
        </label>
    );
}

export default Checkbox;
